var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user (9) 1",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.481 10.2526C11.381 10.2526 12.9048 8.70999 12.9048 6.8288C12.9048 4.94762 11.381 3.38623 9.481 3.38623C7.581 3.38623 6.05724 4.9288 6.05724 6.80999C6.05724 8.69118 7.581 10.2526 9.481 10.2526ZM9.481 4.2892C10.8731 4.2892 12.0018 5.41791 12.0018 6.80999C12.0018 8.20207 10.8731 9.33078 9.481 9.33078C8.08892 9.33078 6.96021 8.22088 6.96021 6.8288C6.96021 5.43673 8.08892 4.2892 9.481 4.2892ZM3.53645 15.614H15.4632C15.7077 15.614 15.9147 15.407 15.9147 15.1625C15.9147 12.7922 13.977 10.8545 11.6067 10.8545H7.39288C5.02258 10.8545 3.08496 12.7922 3.08496 15.1625C3.08496 15.407 3.29189 15.614 3.53645 15.614ZM7.39288 11.7575H11.6067C13.3374 11.7575 14.7483 13.0367 14.9741 14.711H4.02555C4.2513 13.0367 5.66219 11.7575 7.39288 11.7575Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2151ce794f64b2725230948c8dcea8ae.svg";
export { ForwardRef as ReactComponent };